export const ALL_MANUFACTURERS_KEY = 'all';
export const MODELS_PAGE_SIZE = 100;
export const LOAD_MORE_SCROLL_THRESHOLD_ITEMS = 20;

export const cameraInfoKeys = {
    resolution: 'resolutionName',
    superLowLight: 'superLowLight',
    imagerSize: 'imagerSize',
    formFactor: 'formFactor',
} as const;

export interface CameraListModalBrandRow {
    key: string;
    manufacturer: string | null;
    count: number;
}

export const TYPE_ALL_VALUE = 'type_all';